import React from 'react'

import { formatTicketLocationValue } from '../../utilities/helpers'

export default function TicketRow({ ticket }) {
  const fallback = ticket?.generalAdmission ? 'GA' : ''

  return (
    <tr>
      <td className="text-left">
        {formatTicketLocationValue(ticket?.sectionNumber, fallback)}
      </td>
      <td className="text-left">
        {formatTicketLocationValue(ticket?.rowNumber, fallback)}
      </td>
      <td className="text-left">
        {formatTicketLocationValue(ticket?.seatNumber, fallback)}
      </td>
    </tr>
  )
}
